<template>
    <div>
        <h4>FLEX FOUR</h4>
        <p>
            4p News - can be used for News Only or News+Cal orders<br />
            2, 3, or 4 pages of custom-designed content<br />
            up to 3700 characters - base price listed below<br />
            3701-6000 characters - adds $55 to base price<br />
            6001-8500 characters - adds another $55 for a total of $110+base
            price<br />
            Corwin needs to know - if there’s a calendar, will calendar collate
            with news, or ship flat alongside news?<br />
            Uses Calendar pricing (page 1 of this document) and add to this for
            the total price
        </p>

        <table class="w-full" style="max-width: 500px">
            <thead>
                <tr>
                    <td class="text-center">Quantity</td>
                    <td class="text-center">
                        Color Newsletter<br />
                        up to 3700
                    </td>
                    <td class="text-center">
                        Black Newsletter<br />
                        up to 3700
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in computedPrices">
                    <td class="text-center">{{ row.quantity }}</td>
                    <td v-for="price in row.prices">
                        <div class="el-input el-input--minimal-padding">
                            <money
                                v-model.number="price.price"
                                v-bind="money"
                                :disabled="!can(Permissions.EDIT_PRICING)"
                                class="text-right el-input__inner"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as ColorTypes from "../../../constants/color-types";
import { Money, VMoney } from "v-money";
import base_mixin from "./base";

export default {
    mixins: [base_mixin],
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    directives: { money: VMoney },
    components: {
        Money,
    },
    data() {
        return {
            newsletter_type_id: 2,
            ColorTypes,
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: true,
            },
        };
    },
    computed: {
        ...mapState({
            sizes: (state) => state.sizes.data,
            prices: (state) => state.prices.data,
            pricing: (state) => state.config.settings.pricing,
        }),
        computedPrices() {
            let prices = [];
            prices = _.map(
                this.pricing.quantities.calendars.flats,
                (quantity) => {
                    let prices = [];
                    let color_types = [
                        ColorTypes.COLORED,
                        ColorTypes.BLACK_AND_WHITE,
                    ];
                    _.forEach(color_types, (color_type) => {
                        let price = _.find(this.form.prices, {
                            ...this.basePriceAttributes,
                            newsletter_type_id: this.newsletter_type_id,
                            color_type,
                            quantity,
                        });
                        if (!price) {
                            return;
                        }
                        prices.push(price);
                    });
                    return {
                        quantity,
                        prices,
                    };
                }
            );
            return prices;
        },
    },
};
</script>

<style scoped></style>
